export default function (validationField) {
  return {
    'border-danger': validationField.$anyError,
    'border-success': !validationField.$invalid
  }
}